export const BUYER_FORM_URL = "https://forms.gle/Z7gssuFS73y4vuti6";
export const VENDOR_FORM_URL = "https://forms.gle/1zCiuoy3oD2LafWc6";
